<script setup>
import { ref, watch, toRaw } from "vue";
import { storeToRefs } from "pinia";
import { useFilteredFeedStore } from "../stores/FilteredFeed.js";

const toggled = ref(false);
const searchTerm = defineModel();

const store = useFilteredFeedStore();
const { filters } = storeToRefs(store);

watch(filters, () => {
	const watchFilters = toRaw(filters.value);
	if (!Object.keys(watchFilters).length) {
		searchTerm.value = null;
	}
});

function updateSearch() {
	store.updateFilters({
		taxonomy: "keyword",
		term: searchTerm,
	});

	// Easier tracking in GTM
	dataLayer.push({
		'event': 'vue_search',
		'searchTerm': searchTerm.value,
	});
}
</script>
<template>
	<div class="flex w-full items-center bg-white">
		<input
			type="search"
			size="1"
			placeholder="Search by keyword"
			v-model="searchTerm"
			aria-label="Search field"
			@keyup.enter="updateSearch()"
			class="flex-1 text-lg desktop:text-xl text-purple font-serif px-8 leading-none border-0"
		/>
		<button
			class="flex items-center justify-center border-l-4 border-purple text-purple p-6 md:p-8 w-20 h-20 md:w-24 md:h-24 bg-white"
			aria-label="Search button"
			@click.prevent="updateSearch()"
		>
			<em class="text-xl desktop:text-2xl fas fa-search"></em>
		</button>
	</div>
</template>
